export const EVENT_SOURCES = ["application", "builder", "checklist", "flow"];
